import React, { useMemo, useState } from "react";
import {
  getFilterFn,
  renderFilterHeader,
} from "@/react/components/table/useTableFilters";
import ButtonDropdown from "@/react/components/ButtonDropdown";
import { DisplayFilterButton } from "@/react/components/table/components/filter/DisplayFilterButton";
import { DisplayFilter } from "@/react/components/table/components/filter/DisplayFilter";

export function DisplayFilterButtonDropdown({
  displayFilter,
  table,
  setFilterFnId,
  setFilterValue,
  removeFilter,
}) {
  const [isOpen, setIsOpen] = useState(displayFilter.shouldOpen !== false);
  const headerRender = useMemo(
    () => renderFilterHeader(table, displayFilter),
    [displayFilter]
  );
  const filterFn = getFilterFn(displayFilter);

  return (
    <ButtonDropdown
      target={
        <DisplayFilterButton
          headerRender={headerRender}
          displayFilter={displayFilter}
          filterFn={filterFn}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      dropdownKey={`Filters-${displayFilter.column.id}`}
    >
      <DisplayFilter
        headerRender={headerRender}
        displayFilter={displayFilter}
        filterFn={filterFn}
        setFilterFnId={setFilterFnId}
        setFilterValue={setFilterValue}
        removeFilter={removeFilter}
      />
    </ButtonDropdown>
  );
}
